import React from 'react';
import styled from 'styled-components';
import theme from '@/styles/theme';
import media from '@/styles/media';

interface checkbox {
  text?: string;
  onClick?:(event: React.MouseEvent<HTMLElement>) => void;
  onChange?:(event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  checkedColor?: string;
  borderColor?: string
  width?:string;
}
export const Checkbox = ({
  text, onClick, onChange, checked,
  checkedColor = theme.color.purple,
  borderColor = theme.color.border,
  width,
}: checkbox) => (
  <CheckBoxIabel>
    <CheckBoxInput
      onChange={onChange}
      type="checkbox"
      name="checkbox"
      checked={checked}
      checkedColor={checkedColor}
      borderColor={borderColor}
      value={text}
      width={width ?? '22px'}
    />
    {text
    && <CheckBoxP onClick={onClick}>{text}</CheckBoxP>}
  </CheckBoxIabel>
);

interface CheckBoxInputProps{
  checkedColor: string;
  borderColor: string;
  width: string;
}
const CheckBoxInput = styled.input<CheckBoxInputProps>`
  appearance: none;
  width: ${({ width }) => width};
  height: ${({ width }) => width};
  border: 2px solid ${({ borderColor }) => borderColor};
  border-radius: 4px;

  &:hover {    
    border: 2px solid ${({ checkedColor }) => checkedColor};
  }
  &:checked {
    background-color: ${({ checkedColor }) => checkedColor};
    border: 2px solid ${({ checkedColor }) => checkedColor};
    background-position: center bottom;
    background-repeat: no-repeat;
    background-image: url('/assets/images/auth/check-icon.png');
  }
`;

const CheckBoxIabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  cursor: pointer;
`;

const CheckBoxP = styled.p`
  margin-left: 0.5rem;
  font-family:  ${theme.fontFamily.regular};
  font-size: 14px;
  line-height: 16px;
  ${media.lg`
    line-height: 17px;
  `}
`;
